import styled from 'styled-components';

export const GameListLogo = styled.img`
  vertical-align: middle;
  height: 50px;
  margin-right: 20px;

  @media (max-width: 480px) {
    height: 32px;
    margin-right: 8px;
  }
`;
